import { UserApi } from '@/api/user'

const state = () => ({
    mentors: [],
    mentorsPaginatedData: {},
    mentor: null,
    isLoadingMentor: false,
    isSuccessMentor: true,
    messageMentor: '',
})

const getters = {
    mentorList: state => state.mentors,
    mentorsPaginatedData: state => state.mentorsPaginatedData,
    mentor: state => state.mentor,
    isLoadingMentor: state => state.isLoadingMentor,
    isSuccessMentor: state => state.isSuccessMentor,
    messageMentor: state => state.messageMentor,
}

const actions = {
    async fetchAllMentors({ commit }) {
        // let page = 1
        // let perPage = 10
        // let search = ''
        // if (query !== null) {
        //     page = query.page
        //     perPage = query.perPage
        //     search = query.search
        // }
        commit('setMentorIsLoading', true)
        await UserApi.getMentorList()
            .then(response => {
                commit('setMentors', response.data.data)
                    // const pagination = {
                    //     total: response.data.pages.total,
                    //     per_page: response.data.pages.per_page,
                    //     current_page: response.data.pages.current_page
                    // }
                    // commit('setMentorsPaginated', pagination)
                commit('setMentorIsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setMentorIsLoading', false)
            })
    },
    async fetchDetailMentor({ commit }, id) {
        commit('setMentorIsLoading', true)
        await UserApi.detail(id)
            .then(response => {
                // console.log(response)
                commit('setMentorDetail', response.data.data)
                commit('setMentorIsLoading', false)
            })
            .catch(error => {
                console.log(error)
                commit('setMentorIsLoading', false)
            })
    },
    async updateMentor({ commit }, mentor) {
        commit('setMentorIsUpdating', true)
        await UserApi.updateMentor(mentor.id, mentor.data)
            .then(response => {
                // console.log(response)
                commit('saveUpdatedMentor', response.data.data)
                commit('setMentorIsUpdating', false)
            })
            .catch(error => {
                console.log(error)
                commit('setMentorIsUpdating', false)
            })
    },
    async assignMentor({ commit }, data) {
        const payload = {
            uuid: data.uuid,
            short_description: data.short_description,
        }
        await UserApi.addMentor(payload)
            .then(res => {
                if (res.data.success) {
                    commit('setSuccessMentor', true)
                    commit('setMessageMentor', 'Berhasil Menambahkan Mentor')
                } else {
                    commit('setSuccessMentor', false)
                    commit('setMessageMentor', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessMentor', false)
                commit('setMessageMentor', error)
            })
    },
    async deleteMentor({ commit }, id) {
        await UserApi.removeMentor(id)
            .then(res => {
                if (res.data.success) {
                    commit('setSuccessMentor', true)
                    commit('setMessageMentor', 'Berhasil Menghapus Mentor')
                } else {
                    commit('setSuccessMentor', false)
                    commit('setMessageMentor', 'Terjadi Kesalahan')
                }
            })
            .catch(error => {
                commit('setSuccessMentor', false)
                commit('setMessageMentor', error.errors[0].message)
            })
    },
}

const mutations = {
    setMentors: (state, mentors) => {
        state.mentors = mentors
    },

    // setMentorsPaginated: (state, mentorsPaginatedData) => {
    //     state.mentorsPaginatedData = mentorsPaginatedData
    // },

    setMentorDetail: (state, mentor) => {
        state.mentor = mentor
    },

    setMentorIsLoading: (state, isLoadingMentor) => {
        state.isLoadingMentor = isLoadingMentor
    },

    setSuccessMentor: (state, isSuccessMentor) => {
        state.isSuccessMentor = isSuccessMentor
    },

    setMessageMentor: (state, messageMentor) => {
        state.messageMentor = messageMentor
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}